import { makeAutoObservable, runInAction } from 'mobx'

import { http } from '@/utils'
import { message } from 'antd';

class VideoStore {
    //数据列表初始化
    dataList = [];
    //总条数
    total = '';
    //条数
    limit = 2;
    //当前页
    page = 1;

    //弹框显示
    isAshow = false;
    //弹框状态初始化
    isActive = false
    isJdWd = false

    name = '';
    dqid = '';
    //编辑数据存放
    datas = {};
    valueData = {
        lat: 43,
        lng: 125
    }
    //查看数据
    seevalue = {}
    title = ''

    //搜索规则
    filter = ''
    op = ''
    //下拉数据
    selectdata = []

    constructor() {
        makeAutoObservable(this)
    }
    getDataList = async () => {
        if (this.filter && this.op) {
            const res = await http.get(`/coopapi/Video?page=${this.page}&limit=${this.limit}`, {
                params: {
                    filter: this.filter,
                    op: this.op
                }
            })
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.rows))
                this.total = res.data.total
            })
        } else {
            const res = await http.get(`/coopapi/Video?page=${this.page}&limit=${this.limit}`)
            if (res.status === 200) {
                runInAction(() => {
                    this.dataList = JSON.parse(JSON.stringify(res.data.rows))
                    this.total = res.data.total
                })
            }
        }
    }

    //新增
    getAddSheds = async (values) => {
        const res = await http.post(`/coopapi/Video`, values)
        if (res.data.code === 200) {
            runInAction(() => {
                this.getDataList()
            })
        }
    }
    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`coopapi/Video/${id}`)
        console.log(res, "ttt")
        if (res.data.code === 200) {
            runInAction(() => {
                this.getDataList()
            })
        } else {
            message.error(res.data.msg)
        }
    }

    //下拉数据
    newselect = async () => {
        const res = await http.get(`/coopapi/Aigreenhouse`)
        console.log(res, "9090909")
        if (res.status === 200) {
            res.data.rows.map((item, index) => {
                this.selectdata = this.selectdata.concat({ value: `${item.id + ',' + item.house_name}`, label: item.house_name })
            })
        }
    }
}

export { VideoStore }